<script>
    import FlashIcon from "./assets/flash.svg";
    import StarIcon from "./assets/star.svg";
    import BrainIcon from "./assets/brain.svg";
</script>

<div class="max-w-5xl mx-auto px-6 md:px-16">
    <div class="grid md:grid-cols-3 text-center gap-12">
        <div class="flex flex-col items-center gap-5">
            <div class="w-16 h-16 rounded-2xl flex items-center justify-center bg-white shadow-purple-card border border-card-border">
                <img src={FlashIcon} alt="" class="w-8 h-8" />
            </div>
            <div>
                <h3 class="text-lg font-semibold text-navy mb-2">Simpler</h3>
                <p class="text-purple-sub text-base">Intuitive workflows designed for R&D consultants</p>
            </div>
        </div>
        <div class="flex flex-col items-center gap-5">
            <div class="w-16 h-16 rounded-2xl flex items-center justify-center bg-white shadow-purple-card border border-card-border">
                <img src={StarIcon} alt="" class="w-8 h-8" />
            </div>
            <div>
                <h3 class="text-lg font-semibold text-navy mb-2">Smoother</h3>
                <p class="text-purple-sub text-base">Seamless & fast, plug-and-play</p>
            </div>
        </div>
        <div class="flex flex-col items-center gap-5">
            <div class="w-16 h-16 rounded-2xl flex items-center justify-center bg-white shadow-purple-card border border-card-border">
                <img src={BrainIcon} alt="" class="w-8 h-8" />
            </div>
            <div>
                <h3 class="text-lg font-semibold text-navy mb-2">Smarter</h3>
                <p class="text-purple-sub text-base">Powered by cutting-edge AI, trained on DSIT & GfC3</p>
            </div>
        </div>
    </div>
</div>
